module.exports = __webpack_public_path__ + "static/media/home.753fa6f6.svg";